import React from 'react';
import classNames from 'classnames';
import { Text } from '@chakra-ui/react';

interface TabMenuInputProps {
  index: number;
  activeIndex: number;
  disabled: boolean;
  tabName: string;
  onClick: (index: number) => void;
}

const TabMenuItem: React.FC<TabMenuInputProps> = (props) => {
  const { index, activeIndex, disabled, tabName, onClick } = props;

  const handleClick = () => {
    if (!disabled) {
      onClick(index);
    }
  };

  return (
    <li
      onClick={handleClick}
      className={classNames({
        active: index === activeIndex,
        disabled: disabled,
      })}
      title={disabled ? 'This option is currently unavailable' : `Select ${tabName}`}
    >
      <Text as="h5" textStyle="h5">
        {tabName}
      </Text>
    </li>
  );
};

export default TabMenuItem;
export { TabMenuItem };
